import { render } from "./ChangePasswordDone.vue?vue&type=template&id=24ea63c4&scoped=true"
const script = {}

import "./ChangePasswordDone.vue?vue&type=style&index=0&id=24ea63c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ea63c4"]])

export default __exports__